/**
 * Models - Notification Types
 */
export enum NotificationStatus {
  UNREAD = 'unread',
  READ = 'read',
  ARCHIVED = 'archived'
}

export enum NotificationType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error'
}

export interface INotification {
  id: number;
  title: string;
  description?: string;
  type: NotificationType;
  status: NotificationStatus;
  icon?: string;
  timestamp: Date;
  actionUrl?: string;
  read: boolean;
  pinned?: boolean;
}

export interface INotificationPayload {
  title: string;
  description?: string;
  type?: NotificationType;
  actionUrl?: string;
}

export interface INotificationFilter {
  status?: NotificationStatus;
  type?: NotificationType;
  read?: boolean;
  search?: string;
}
